import src from "IMAGE";
export default { src, width: 76, height: 76, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
